import ServiceQrWallet from"./ServiceQrWallet";export default ServiceQrWallet;